const mediaAreas = document.querySelectorAll(".single_card");
mediaAreas.forEach(mediaArea => {
  const playButton = mediaArea.querySelector(".play_btn");
  const video = mediaArea.querySelector("video");

  if (playButton && video) {
    // iOS compatibility: requires user interaction for playback
    video.controls = false;
    video.playsInline = true;
    video.muted = false; // Some mobile browsers require muted for autoplay

    // Play on button click
    playButton.addEventListener("click", () => {
      video.play().then(() => {
        playButton.style.display = "none";
      }).catch(error => {
        console.error("Video play failed:", error);
      });
    });

    // Pause on video click
    video.addEventListener("click", () => {
      if (!video.paused) {
        video.pause();
        playButton.style.display = "flex";
      }
    });
  }
});









